import "react-datepicker/dist/react-datepicker.css";
import { useParams } from "react-router-dom";

import { useEffect, useState } from "react";

import getCurrentUserId from "../../reduxSaga/sagas/requests/currentUserId";
import ProductOrderService from "../../services/ProductOrderService";
import DataTableWarehouseMouvements from "../../ui/DataTableWarehouseMouvements";
import withLoader from './../../components/layouts/WithLoader';
import { TextField } from "@material-ui/core";
const WarehouseMouvement = ({ startLoading, stopLoading }) => {
  const [transactions, setTransactions] = useState([]);

  const [dateBegin, setDateBegin] = useState("any");
  const [dateEnd, setDateEnd] = useState("any");



  const onGetDocumentsByFilter = () => {
    startLoading();
    ProductOrderService.getProductTransactionHistoryByWarhouseV2(
      sessionStorage.getItem("idWarehouseMouvement"),
      getCurrentUserId(), dateBegin, dateEnd
    )
      .then((response) => {
        console.log(
          "getProductTransactionHistoryByWarhouse",
          response.data.success
        );
        setTransactions(response.data.success);
      })
      .catch(() => {
        alert("problème de connexion");
      }).finally(() => {
        stopLoading()
      })
  };

  const onChangeDateBegin = (event) => {
    const selectedValue = event.target.value;

    // Check if the value includes a time
    const updatedValue = selectedValue.includes("T")
      ? selectedValue.split(":").slice(0, 2).join(":") + ":00" // If time exists, set seconds to 00
      : selectedValue + "T00:00:00"; // If no time, set to the first second of the day (00:00:00)

    setDateBegin(updatedValue);
  };


  const onChangeDateEnd = (event) => {
    const selectedValue = event.target.value;

    // Check if the value includes a time
    const updatedValue = selectedValue.includes("T")
      ? selectedValue.split(":").slice(0, 2).join(":") + ":59" // Set seconds to 59 if time exists
      : selectedValue + "T23:59:59"; // Set to the last second of the day (23:59:59) for date input

    setDateEnd(updatedValue);
  };



  return (
    <div className="content-wrapper" style={{ marginTop: "0" }}>
      <section className="content-header">

      </section>


      <div className="content ">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-12">
              <div class="card card-dark">
                <div class="card-body">
                  <div class="row">


                    <div className="col-sm-6">
                      <div className="form-group">
                        <label htmlFor="inputName">Date début</label>

                        <TextField
                          style={{ width: "100%" }}
                          className="col-sm-12"
                          variant="outlined"
                          // value={dateBegin}
                          onChange={onChangeDateBegin}
                          id="date"
                          type="date"
                          defaultValue="date"
                          InputLabelProps={{
                            shrink: true,
                          }}
                          size="small"
                        />
                      </div>
                    </div>
                    <div className="col-sm-6">
                      <div className="form-group">
                        <label htmlFor="inputName">Date fin</label>
                        <TextField
                          style={{ width: "100%" }}
                          className="col-sm-12"
                          variant="outlined"
                          // value={dateEnd}
                          onChange={onChangeDateEnd}
                          id="date"
                          type="date"
                          defaultValue="date"
                          InputLabelProps={{
                            shrink: true,
                          }}
                          size="small"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="card-footer">
                  <div className="col-sm-12  text-center">
                    <button
                      className="btn btn-dark"
                      onClick={onGetDocumentsByFilter}
                    >
                      Valider le choix
                    </button>
                  </div>
                </div>
              </div>  {transactions.length !== 0 && (
                <DataTableWarehouseMouvements
                  warehouseName={sessionStorage.getItem("nameWarehouseMouvement")}
                  listTransactions={transactions}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default withLoader(WarehouseMouvement);
